import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  FormControl,
  FormGroup
} from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Field, change, formValueSelector, reduxForm } from 'redux-form';
import IncrementButton from '../IncrementButton';
import FooterButton from './FooterButton';
import IncrementBtn from './IncrementBtn';
import SidePanel from './SidePanel';
import stepThreeIllustration from '/public/SiteImages/step3.svg';

import messages from '../../locale/messages';
import SelectFieldComponent from '../Common/FormField/SelectFieldComponent';
import update from './update';

import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';

class Page3 extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    previousPage: PropTypes.any,
    beds: PropTypes.number,
    nextPage: PropTypes.any,
    bedTypes: PropTypes.array,
    bathrooms: PropTypes.number,
    isExistingList: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      bedType: [],
      beds: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      bedrooms: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      personCapacity: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      bathrooms: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      bathroomType: []

    }
    this.handleClick = this.handleClick.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { listingFields, beds, change, bedTypes } = this.props;
    const { bedType } = this.state;
    let obj, bedsArray = [];

    if (listingFields != undefined) {
      this.setState({
        bedType: listingFields.bedType,
        beds: listingFields.beds[0],
        bedrooms: listingFields.bedrooms[0],
        personCapacity: listingFields.personCapacity[0],
        bathrooms: listingFields.bathrooms[0],
        bathroomType: listingFields.bathroomType,
      });
    }

    if ((bedTypes && beds != bedTypes.length) || (bedTypes && bedTypes.length == 0)) {
      Array(beds).fill().map((i, index) => {
        obj = {
          bedCount: 1,
          bedType: listingFields.bedType && listingFields.bedType.length > 0 ? listingFields.bedType[0].id : null,
        };
        bedsArray.push(obj);
      })
      change('bedTypes', bedsArray);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields } = nextProps;
    if (listingFields != undefined) {
      this.setState({
        bedType: listingFields.bedType,
        beds: listingFields.beds[0],
        bedrooms: listingFields.bedrooms[0],
        personCapacity: listingFields.personCapacity[0],
        bathrooms: listingFields.bathrooms[0],
        bathroomType: listingFields.bathroomType,
      });
    }
  }


  renderIncrementButton = (field) => (
    <IncrementButton
      {...field}
      circleLayout
    />
  );

  renderIncrementBtn = (input, dispatch) => (
    <IncrementBtn
      {...input}
      onChange={this.handleClick}
      circleLayout
    />
  );


  renderFormControlSelect = ({ input, label, meta: { touched, error }, children, className }) => {
    return (
      <div>
        <FormControl componentClass="select" {...input} className={className} >
          {children}
        </FormControl>
      </div>
    )
  }

  renderBedTypes = ({ fields, meta: { error, submitFailed } }) => {
    const { bedType } = this.state;
    let bedTypeValue = [];

    bedType && bedType.map((item, key) => {
      if (item.isEnable == 1) {
        bedTypeValue.push({
          value: item?.id,
          label: item?.itemName
        })
      }
    })
    return (
      <div className={s.spaceTop2}>
        {
          fields.map((beds, index) => (

            <div key={index}>
              <FormGroup className={s.space5}>
                <Field
                  name={`${beds}.bedType`}
                  type="text"
                  component={SelectFieldComponent}
                  inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                  options={bedTypeValue}
                />

              </FormGroup>
            </div>
          ))
        }
      </div>
    )
  }

  async handleClick(e) {
    const { beds, bedTypes, change } = this.props;
    const { bedType } = this.state;

    let bedTypesValue = Object.keys(bedTypes).map(function (key) {
      return bedTypes[key];
    });

    let updatedBedTypesArray = (bedTypesValue && bedTypesValue.length > 0) ? bedTypesValue.slice(0) : [];
    let updatedBedCount = beds + 1;
    let obj = {};

    if (Number(beds) < Number(e)) {
      obj = {
        bedCount: updatedBedCount,
        bedType: bedType.length > 0 ? bedType[0].id : null,
      };
      try {
        updatedBedTypesArray.push(obj);
      } catch (e) {

      }
    } else if ((Number(beds) >= Number(e)) || (Number(e) > 2)) {
      updatedBedTypesArray.splice(bedTypesValue.length - 1, 1);
    }

    await change('bedTypes', []);
    await change('bedTypes', updatedBedTypesArray);
  }

  render() {
    const { handleSubmit, previousPage, nextPage, isExistingList, formPage, step } = this.props;
    const { formatMessage } = this.props.intl;
    const { bedrooms, beds, personCapacity, bathrooms, bathroomType } = this.state;

    let bathroomTypeValue = [];
    /* let path = isExistingList ? "map" : "location"; */
    let path = "map";

    bathroomType && bathroomType.map((item, key) => {
      if (item.isEnable == 1) {
        bathroomTypeValue.push({
          value: item?.id,
          label: item?.itemName
        })
      }
    })

    return (
      <div className={s.eslipinBg}>
        <div className={cx(s.grid, 'arrowPosition')}>
          <SidePanel
            badge="Información del alojamiento"
            title="Agrega algunos datos básicos sobre"
            highlightText=" tu espacio"
            subtitle="Cuéntanos cuántas personas pueden disfrutar de tu alojamiento, para que podamos mostrarlo de la mejor manera"
            iconImg={stepThreeIllustration}
          />
          <form onSubmit={handleSubmit}>
            <div className={s.stepRightCard}>
              <div className={s.landingMainContent}>
                <label className={s.amenitiesSpacesTitle}>
                  Agrega algunos datos básicos sobre tu espacio
                </label>
                <div className={s.fieldCard}>
                  <div className={s.fieldCardRow}>
                    <div className={s.fieldCardInfo}>
                      <p className={s.roomTypeCardTitle}>
                        <FormattedMessage {...messages.totalGuests} />
                      </p>
                      <span className={s.roomTypeCardDesc}>Incluye a todas las personas, considerando la cantidad de camas disponibles.</span>
                    </div>
                    <div className={s.fieldCardControls}>
                      <Field
                        name="personCapacity"
                        type="text"
                        component={this.renderIncrementButton}
                        /* labelSingluar={personCapacity.itemName}
                        labelPlural={personCapacity.otherItemName} */
                        maxValue={personCapacity.endValue}
                        minValue={personCapacity.startValue}
                        incrementBy={1}
                      />
                    </div>
                  </div>
                </div>
                <div className={s.fieldCard}>
                  <div className={s.fieldCardRow}>
                    <div className={s.fieldCardInfo}>
                      <p className={s.roomTypeCardTitle}>
                        <FormattedMessage {...messages.howManyBedrooms} />
                      </p>
                      <span className={s.roomTypeCardDesc}>Considera las habitaciones con una o más camas (no incluye salas con sofa-cama)</span>
                    </div>
                    <div className={s.fieldCardControls}>
                      <Field
                        name="bedrooms"
                        type="text"
                        component={this.renderIncrementButton}
                        /* labelSingluar={bedrooms.itemName}
                        labelPlural={bedrooms.otherItemName} */
                        minValue={bedrooms.startValue}
                        incrementBy={1}
                        maxValue={bedrooms.endValue}
                      />
                    </div>
                  </div>
                </div>
                <div className={s.fieldCard}>
                  <div className={s.fieldCardRow}>
                    <div className={s.fieldCardInfo}>
                      <p className={s.roomTypeCardTitle}>
                        <FormattedMessage {...messages.howManyBeds} />
                      </p>
                      <span className={s.roomTypeCardDesc}>Incluye camas individuales, queen, king, sofa-camas, etc.</span>
                    </div>
                    <div className={s.fieldCardControls}>
                      <Field
                        name="beds"
                        type="text"
                        component={this.renderIncrementButton}
                        /* labelSingluar={beds.itemName}
                        labelPlural={beds.otherItemName} */
                        minValue={beds.startValue}
                        incrementBy={1}
                        maxValue={beds.endValue}
                      />
                    </div>
                  </div>
                </div>
                <div className={s.fieldCard}>
                  <div className={s.fieldCardRow}>
                    <div className={s.fieldCardInfo}>
                      <p className={s.roomTypeCardTitle}>
                        <FormattedMessage {...messages.howManyBathrooms} />
                      </p>
                      <span className={s.roomTypeCardDesc}>Indica el número total de baños disponibles</span>
                    </div>
                    <div className={s.fieldCardControls}>
                      <Field
                        name="bathrooms"
                        type="text"
                        component={this.renderIncrementButton}
                        /* labelSingluar={bathrooms.itemName}
                        labelPlural={bathrooms.otherItemName} */
                        maxValue={bathrooms.endValue}
                        minValue={0.5}
                        incrementBy={0.5}
                      />
                    </div>
                    <span className={s.roomTypeCardDesc}>Nota: 0.5 hace referencia a un baño sin ducha</span>
                  </div>
                </div>
                {/* <div className={s.fieldCard}>
                  <div className={s.fieldCardHeader}>
                    <label className={s.roomTypeCardTitle}>
                      <FormattedMessage {...messages.bathroomType} />
                    </label>
                    <span className={s.roomTypeCardDesc}>Tipo de baño del espacio</span>
                  </div>
                  <FormGroup className={s.formGroup}>
                    <Field name="bathroomType"
                      component={SelectFieldComponent}
                      inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                      options={bathroomTypeValue}
                    />
                  </FormGroup>
                </div> */}
                {/* <FieldArray name="bedTypes" component={this.renderBedTypes} className={s.spaceTop2} /> */}
              </div>
              <FooterButton
                nextPage={nextPage}
                previousPage={previousPage}
                nextPagePath={path}
                previousPagePath={"room-type"}
                formPage={formPage}
                step={step}
              />

            </div>
          </form>
        </div>
      </div>
    )
  }
}


Page3 = reduxForm({
  form: 'ListPlaceStep1', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onSubmit: update
})(Page3);

// Decorate with connect to read form values
const selector = formValueSelector('ListPlaceStep1'); // <-- same as form name

const mapState = (state) => ({
  isExistingList: state.location.isExistingList,
  listingFields: state.listingFields.data,
  beds: selector(state, 'beds'),
  bedCount: selector(state, 'beds'),
  bedTypes: selector(state, 'bedTypes'),
});

const mapDispatch = {
  change,
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Page3)));